import { useTenant } from '@emerald-works-nova/auth'
import { useMemo } from 'react'
import consts from '../consts'
import { BROWSER, FREE, SUSPENDED } from '../services/cognito/userGroups'
import useGroup from './useGroup'

export const useShouldHideCommentsInteractions = () => {
  const tenant = useTenant()
  const isClub = tenant.pk === consts.DEFAULT_CLUB_PK
  const { isInGroup } = useGroup()
  const shouldHideCommentsInteractions = useMemo(() => isInGroup([FREE, SUSPENDED, BROWSER]), [isInGroup])

  return {
    shouldHideCommentsInteractions: isClub && shouldHideCommentsInteractions
  }
}
